import { useMemo, useState } from 'react';

import { ForumIcon, GroupIcon, NotificationsIcon } from '@orijinworks/frontend-commons';
import { checkUserRoleType } from './mappers/feedUtility';
import { ROLES } from '../../../constants';

export const useFeedConfigureHook = (props) => {
  const {
    unreadCount,
    unreadAnnouncementsCount,
    unreadMessagesCount,
    resetAnnouncementAttachments
  } = props;

  const [showNewMessageModal, setShowNewMessageModal] = useState(false);
  const [modalContext, setModalContext] = useState('');
  const [editSettings, setEditSettings] = useState(null);


  // Event handlers
  const handleNewMessage = (context) => {
    setShowNewMessageModal(true);
    setModalContext(context);
  };

  const handleCloseModal = () => {
    setShowNewMessageModal(false);
    resetAnnouncementAttachments?.();
  };

  const handleOpenEditModal = (settings) => {
    setEditSettings(settings || null);
    setShowNewMessageModal(true);
    setModalContext('edit');
  };

  // Computed values
  const allCount = unreadCount || 0;

  // Check if user is attorney
  const isAttorney = useMemo(() => {
    return checkUserRoleType([ROLES.ATTORNEY]);
  }, []);

  // Tab configuration data
  const tabsConfig = useMemo(() => {
    return [
      {
        key: 'all',
        label: 'All',
        value: 'All',
        Icon: ForumIcon,
        hasUnreadCount: (allCount ?? 0) > 0,
        unreadCount: allCount,
        hide: true,
      },
      {
        key: 'messages',
        label: 'Messages',
        value: 'Messages',
        Icon: GroupIcon,
        hasUnreadCount: (unreadMessagesCount ?? 0) > 0,
        unreadCount: unreadMessagesCount || 0,
        hide: false
      },
      {
        key: 'announcements',
        label: 'Announcements',
        value: 'Announcements',
        Icon: NotificationsIcon,
        hasUnreadCount: (unreadAnnouncementsCount ?? 0) > 0,
        unreadCount: unreadAnnouncementsCount ?? 0,
        hide: isAttorney, // Hide announcements tab if user is attorney
      },
    ]
  }, [allCount, unreadAnnouncementsCount, unreadMessagesCount, isAttorney]);

  const onTabChangeHandler = (event, value) => {
    props.onTabChangeHandler && props.onTabChangeHandler(event, value);
  };
  return {
    // State
    showNewMessageModal,
    modalContext,
    editSettings,

    // Computed values
    tabsConfig,
    allCount,

    // Event handlers
    handleNewMessage,
    handleCloseModal,
    handleOpenEditModal,
    onTabChangeHandler,
  };
};